module.exports = __webpack_public_path__ + "media/images/index/product_line/travel-cae714d8c2abd29f4de7d45e109da354.svg";